import { InputAdornment, SxProps } from '@mui/material'
import { TextFieldElement, useFormContext } from 'react-hook-form-mui'

interface PhoneNumberFieldProps {
  name: string;
  label?: string;
  removeField?: () => void;
  onBlurCallback?: () => void;
  sx?: SxProps;
  onChangeCallback?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  size?: "small" | "medium";
  autoFocus?: boolean;
}

const PhoneNumberField = ({ 
  name, 
  label = "", 
  removeField,
  onBlurCallback,
  fullWidth = true,
  onChangeCallback,
  size = "medium",
  sx,
  autoFocus = false,
}: PhoneNumberFieldProps) => {
  
  const { watch, formState: { errors } } = useFormContext();
  const parsedValue = watch(name)?.length === 12 && watch(name)?.startsWith('91') ? watch(name)?.slice(2) : watch(name)?.length === 13 && watch(name)?.startsWith('+91') ? watch(name)?.slice(3) : watch(name);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    // If the field is empty and we have the removeField function, call it
    if (e.target.value === '' && removeField) {
      removeField();
    }
    
    // Call the onBlurCallback if provided
    if (onBlurCallback) {
      onBlurCallback();
    }
  };

  return (
    <TextFieldElement
      name={name}
      label={label}
      fullWidth={fullWidth}
      required
      type="tel"
      onBlur={handleBlur}
      size={size}
      sx={sx}
      autoFocus={autoFocus}
      slotProps={{
        htmlInput: {
          minLength: 10,
          maxLength: 10,
          value: parsedValue,
          pattern: "[0-9]{10}",
          autoComplete: "no-name",
        },
        input: {
          startAdornment: <InputAdornment position="start">+91</InputAdornment>,
        },
        inputLabel: {
          sx: {
            '& .MuiFormLabel-asterisk': {
              color: 'error.main',
              fontSize: '24px',
            },
          },
        },
      }}
      helperText={errors[name]?.message as string}
      error={!!errors[name]}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onChangeCallback?.(e);
      }}
    />
  )
}

export default PhoneNumberField